// frontend/src/shared/theme/colors.js

const colors = {
  // 🎯 Primário
  primary: "#6A4AA6",
  primaryDark: "#4B367C",
  primarySoft: "#F3EDF9",

  // ✨ Acentos
  accent: "#9D77F0",
  accentSoft: "#EEE7F8",

  // 🧱 Superfícies
  background: "#F7F5FB",
  surface: "#FFFFFF",
  surfaceSoft: "#FBFAFE",

  // 🪟 Bordas
  border: "#E7E0F2",
  borderSoft: "#EEE8F7",

  // 📝 Texto
  textPrimary: "#1F1732",
  textSecondary: "#6C6187",
  textMuted: "#8B7DA8",

  // ✅ Estados genéricos
  success: "#22C55E",
  successDark: "#166534",
  successSoft: "rgba(34, 197, 94, 0.10)",

  warning: "#ED6C02",
  warningDark: "#92400E",
  warningSoft: "rgba(245, 158, 11, 0.10)",

  error: "#EF4444",
  errorDark: "#991B1B",
  errorSoft: "rgba(239, 68, 68, 0.10)",

  info: "#3B82F6",
  infoDark: "#1E3A8A",
  infoSoft: "rgba(59, 130, 246, 0.10)",

  // 🟢 STATUS SEMÂNTICO (NOVO PADRÃO)
  statusSuccess: "#22C55E",
  statusSuccessSoft: "rgba(34, 197, 94, 0.10)",

  statusWarning: "#F59E0B",
  statusWarningSoft: "rgba(245, 158, 11, 0.10)",

  statusDanger: "#EF4444",
  statusDangerSoft: "rgba(239, 68, 68, 0.10)",

  statusNeutral: "#6C6187",
  statusNeutralSoft: "rgba(108, 97, 135, 0.10)",

  // 📌 STATUS LEGADO (manter compatibilidade)
  statusPending: "#EF4444",
  statusScheduled: "#6C6187",
  statusDone: "#22C55E",

  // 🎯 Ações
  buttonPrimary: "#6A4AA6",
  buttonText: "#FFFFFF",

  // 🎯 Backgrounds especiais
  iconBg: "#F3EDF9",
  highlight: "#F6F2FB",
};

export default colors;